
import { Component, Vue } from 'vue-property-decorator'
import { postFetch } from '@/service/common'
import { cryptoEncrypt, isNotNull, isNull } from '@/utils/fun'
import { captchaUrl } from '@/service/url'
@Component({})
export default class Register extends Vue {
  form: any = {}
  url = ''
  codeId = 0
  timeNumber = 0
  showTimer = false
  timer: any = null
  loginLoading = false
  sendLoading = false
  validatePass = (rule: object, value: string, callback: Function) => {
    if (isNull(value)) {
      callback(new Error('请输入密码'))
    } else {
      if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/.test(value)) {
        callback(new Error('密码必须8位以上，包含特殊字符+大小写字母+数字组合'))
      } else if (isNotNull(this.form.re_password)) {
        const vm: any = this.$refs.ruleForm
        vm.validateField('re_password')
      }
      callback()
    }
  }
  validatePass2 = (rule: object, value: string, callback: Function) => {
    if (isNull(value)) {
      callback(new Error('请再次输入密码'))
    } else if (value !== this.form.password) {
      callback(new Error('两次密码输入不一致'))
    } else {
      callback()
    }
  }
  rules: object = {
    username: [
      { required: true, message: '请输入用户名', trigger: 'change' },
      {
        pattern: /^[0-9A-Za-z@#-_]{4,20}$/,
        message: '用户名必须为4-20位，只允许大小写字母数字以及“@#-_”',
        trigger: 'change',
      },
    ],
    password: [{ validator: this.validatePass, trigger: 'change' }],
    re_password: [{ validator: this.validatePass2, trigger: 'change' }],
    email: [
      { required: true, message: '邮箱不能为空', trigger: 'change' },
      {
        pattern: /^[^@]*@[^@]*$/,
        message: '请输入格式正确的邮箱',
        trigger: 'change',
      },
    ],
    mobile: [
      {
        required: true,
        message: '请输入手机号',
        trigger: 'change',
      },
    ],
    vcode: [
      {
        required: true,
        message: '请输入验证码',
        trigger: 'change',
      },
    ],
    protocol: [
      {
        required: true,
        message: '请先阅读并同意《小芒用户协议》',
        trigger: 'change',
      },
    ],
  }
  created() {
    this.getCodeImage()
  }
  beforeDestroy() {
    clearInterval(this.timer)
  }

  handleSubmit() {
    const vm: any = this.$refs.ruleForm
    vm.validate((valid: any) => {
      if (valid) {
        const { img_code, protocol, password, re_password, ...rest } = this.form
        const params = {
          ...rest,
          password: cryptoEncrypt(password),
          re_password: cryptoEncrypt(re_password),
        }
        this.doRegister(params)
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  async doRegister(params: object) {
    this.loginLoading = true
    try {
      const { code, msg }: any = await postFetch('register', params)
      if (code === 0) {
        this.$message.success('注册成功，请登录')
        this.$emit('change-type', 'login')
      } else {
        this.$message.error(msg)
      }
    } catch (error) {
      console.log(
        '🚀 ~ file: LoginContent.vue ~ line 115 ~ LoginContent ~ doLogin ~ error',
        error
      )
    }
    this.loginLoading = false
    this.getCodeImage()
  }

  async getCodeImage() {
    const codeId = new Date().getTime() + Math.floor(Math.random() * 1000)
    this.codeId = codeId
    this.url = `${captchaUrl}?code_id=${codeId}`
  }

  async sendMessage() {
    if (isNull(this.form.mobile)) {
      this.$message.error('请先输入手机号')
      return false
    }
    if (isNull(this.form.img_code)) {
      this.$message.error('请先输入图片验证码')
      return false
    }
    const params = {
      mobile: this.form.mobile,
      img_code: this.form.img_code,
      code_id: this.codeId,
      oper: 'register', //注册
    }
    this.sendLoading = true
    try {
      const { code, msg }: any = await postFetch('sendSmsCode', params)
      if (code === 0) {
        this.$message.success('短信已发送，请注意查收')
        this.timeNumber = 60
        this.showTimer = true
        this.timer = setInterval(() => {
          if (this.timeNumber > 0) {
            this.timeNumber--
          } else {
            clearInterval(this.timer)
            this.showTimer = false
            this.getCodeImage()
          }
        }, 1000)
      } else {
        this.$message.error(msg)
      }
    } catch (error) {
      console.log(
        '🚀 ~ file: LoginContent.vue ~ line 115 ~ LoginContent ~ doLogin ~ error',
        error
      )
    }
    this.sendLoading = false
  }
}
